var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgVk = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_259_10463)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask0_259_10463",
  width: 16,
  height: 16,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M15.92 0H.08v16h15.84z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_259_10463)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#07F",
  d: "M.08 7.68c0-3.62 0-5.43 1.11-6.56C2.31 0 4.1 0 7.7 0h.63c3.58 0 5.37 0 6.49 1.12 1.11 1.13 1.11 2.94 1.11 6.56v.64c0 3.62 0 5.43-1.11 6.56C13.69 16 11.9 16 8.3 16h-.63c-3.58 0-5.37 0-6.49-1.12-1.1-1.13-1.1-2.94-1.1-6.56z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M8.51 11.53c-3.61 0-5.67-2.5-5.76-6.66h1.81c.06 3.05 1.4 4.34 2.45 4.61V4.87h1.7V7.5c1.05-.11 2.14-1.31 2.51-2.63h1.7a5.08 5.08 0 0 1-2.31 3.32c.84.4 2.2 1.44 2.71 3.34h-1.87A3.27 3.27 0 0 0 8.7 9.15v2.38h-.2Z"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_259_10463"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})))));
export default SvgVk;